export default __webpack_public_path__ + "static/prinoth-caa91eb9600a0f4e10cc3141cd49f8df.webp";